import Controller from "./pickupDropoff.controller";
import template from "./pickupDropoff.html";

const pickupDropoff = {
  template,
  controller: Controller,
  bindings: {
    stations: "<",
    pickup: "=",
    dropoff: "=",
    invalidPickup: "=",
    invalidDropoff: "=",
  },
};

export default pickupDropoff;



// WEBPACK FOOTER //
// ./src/components/pickupDropoff/pickupDropoff.component.js